import { SwitchElement, TextFieldElement } from 'react-hook-form-mui';

import { Grid } from '@mui/material';

const CanelReasonForm: React.FC = () => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <SwitchElement label="Ativa" name="active" />
    </Grid>
    <Grid item>
      <TextFieldElement label="Nome" name="name" required />
    </Grid>
    <Grid item>
      <TextFieldElement label="Descrição" name="description" />
    </Grid>
  </Grid>
);

export default CanelReasonForm;
